import { render } from "./ToggleWithText.vue?vue&type=template&id=3e189e7c&scoped=true&ts=true&lang=pug"
import script from "./ToggleWithText.vue?vue&type=script&lang=ts"
export * from "./ToggleWithText.vue?vue&type=script&lang=ts"

import "./ToggleWithText.vue?vue&type=style&index=0&id=3e189e7c&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e189e7c"]])

export default __exports__